import { render, staticRenderFns } from "./RestoreStepTwo.vue?vue&type=template&id=fab87af8&scoped=true&"
import script from "./RestoreStepTwo.vue?vue&type=script&lang=js&"
export * from "./RestoreStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./RestoreStepTwo.vue?vue&type=style&index=0&id=fab87af8&prod&lang=scss&scoped=true&"
import style1 from "./RestoreStepTwo.vue?vue&type=style&index=1&id=fab87af8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab87af8",
  null
  
)

export default component.exports